import { Text } from "@portal/components/primitives";

export const AdminAssistantChartNotice = ({
	children,
	danger = false,
}: {
	children: string;
	danger?: boolean;
}) => (
	<Text type="caption" color={danger ? "danger" : "tertiary"} data-testid="assistant-chart-notice">
		{children}
	</Text>
);
